import { useCan } from '@discovr/common';
import { useCampaignCapabilitiesStore } from '@discovr/features';
import { SCOPES } from '@discovr/types';
import { canWriteAtLevel } from '../../../lib/campaignPermissions';

/** The scope says the role may write outreach at all; the campaign's effective
 *  grant says whether it may here (E2E G2: a `read` grant saw every write
 *  action and ate 404s). A level not loaded yet reads as read. */
export function useCanWriteOutreach(): boolean {
  const accessLevel = useCampaignCapabilitiesStore((s) => s.accessLevel);
  const hasWriteScope = useCan(SCOPES.outreachWrite);
  return hasWriteScope && canWriteAtLevel(accessLevel);
}
